import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("dic_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).join(" ");
  return e?.message || "Si è verificato un errore";
}

// Parser SSE robusto: bufferizza chunk parziali, gestisce split multibyte
// (TextDecoder stream) e fa il flush finale per non perdere l'ultimo token.
export async function streamTokens(res, onToken) {
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  const drain = () => {
    let idx;
    while ((idx = buf.indexOf("\n\n")) !== -1) {
      const raw = buf.slice(0, idx);
      buf = buf.slice(idx + 2);
      const line = raw.replace(/^data:\s?/, "").trim();
      if (!line || line === "[DONE]") continue;
      try {
        const { token } = JSON.parse(line);
        if (token) onToken(token);
      } catch { /* frammento SSE non ancora completo: ignorato di proposito */ }
    }
  };
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    drain();
  }
  buf += dec.decode();
  drain();
  const line = buf.replace(/^data:\s?/, "").trim();
  if (line && line !== "[DONE]") {
    try {
      const { token } = JSON.parse(line);
      if (token) onToken(token);
    } catch { /* frammento SSE finale non valido: ignorato di proposito */ }
  }
}
